import { GET, POST } from "Data/API/Request";
import type {
	ApiUser, ForgotPasswordPayload, LoginUserPayload, ResetPasswordPayload, WithApiData,
	RegisterUserPayload, LoginUserResponse
} from "Interfaces";
import { UserMeta, ResourceType
} from "Interfaces";
import { deserializeJsonApiData, serializeJsonApiData } from "Data/Utils/JsonApi";

export const loginUser = (loginUserPayload: LoginUserPayload): Promise<LoginUserResponse> => {
	return POST<ApiUser>("auth/login", loginUserPayload).then((response: WithApiData<ApiUser>) => {
		return deserializeJsonApiData<ApiUser>(response).then((apiUser: ApiUser) => {
			const { id, email, name, verified, meta } = apiUser;

			return {
				user: {
					id,
					email,
					name,
					verified,
					role: meta?.[ UserMeta.ROLES ]
				},
				token: meta?.[ UserMeta.TOKEN ],
				pusherKey: meta?.[ UserMeta.PUSHER_KEY ],
				hostnameLimit: meta?.[ UserMeta.HOSTNAME_LIMIT ]
			} as LoginUserResponse;
		});
	});
};

export const registerUser = (registerUserPayload: RegisterUserPayload) => {
	const serializedPayload = serializeJsonApiData(ResourceType.USERS, registerUserPayload);

	return POST(
		"auth/register",
		serializedPayload
	);
};

export const forgotPassword = (payload: ForgotPasswordPayload) => {
	return POST(
		"auth/forgot-password",
		payload
	);
};

export const resetPassword = (payload: ResetPasswordPayload) => {
	return POST(
		"auth/reset-password",
		payload
	);
};

export const verifyEmail = (id: string, emailHash: string, timestamp: string, signatureHash: string) => {
	return GET(
		`auth/verify-email/${ id }/${ emailHash }?expires=${ timestamp }&signature=${ signatureHash }`, undefined
	);
};
